import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { DevExtremeModule } from 'devextreme-angular';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-double-check-dialog',
    templateUrl: './double-check-dialog.component.html',
    styleUrls: ['./double-check-dialog.component.scss'],
    imports: [CommonModule, DevExtremeModule, CurrencyPipe],
    standalone: true,
})
export class DoubleCheckDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    batches: any[];
    doubleCheck: any;
    doubleCheckForCheckNumbers: any;
    batchId: number;
    batch1Id: number;
    batch2Id: number;
    disableCompare = false;
    selectedBatches: any = {};
    doubleCheckComplete = false;
    doubleCheckPassed = false;
    cashBreakdownCheck: any = {
        batchTotalCash: 0,
        cashBreakdownTotalCash: 0,
    };

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        this.batches = await this.uow.getBatchList(500);
        if (!!this.batchId) {
            this.batch1Id = Number(this.batchId);
            this.cashBreakdownCheck = await this.uow.getDoubleCheckForCashBreakdown(this.batch1Id);
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    async compare() {
        // console.log(this.batches);
        if (!this.batch1Id || !this.batch2Id) return;
        this.disableCompare = true;
        this.appInfo.pleaseWaitShow();
        this.doubleCheck = await this.uow.getDoubleCheck(this.batch1Id, this.batch2Id);
        this.doubleCheckForCheckNumbers = await this.uow.getDoubleCheckForCheckNumbers(this.batch1Id, this.batch2Id);

        this.cashBreakdownCheck = await this.uow.getDoubleCheckForCashBreakdown(this.batch1Id);

        this.doubleCheckComplete = true;
        this.doubleCheckPassed = this.doubleCheck.length === 0 && this.doubleCheckForCheckNumbers.length === 0 && this.cashBreakdownCheck.isMatch;

        this.createBatchNote(this.doubleCheckPassed ? 'passed' : 'failed');
        this.appInfo.pleaseWaitHide();
        this.appInfo.notifyToast(`Compare ${this.doubleCheckPassed ? 'complete' : 'failed'}!`, this.doubleCheckPassed ? 'success' : 'error', 2000);
        // this.disableCompare = false;
    }

    createBatchNote(passFail: string) {
        const note = this.uow.contributionBatchNotes.createEntity({
            batchId: this.batchId,
            note: `Batch double check ${passFail}`,
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
        }) as any;
        this.uow.commit();
    }

    close() {
        // this.modalRef.hide();
        this.result.next({ result: false });
    }
}
